/**
 * One-time seed script for Firestore normative_config collection.
 *
 * Usage: import { seedNormativeConfig } from './seedNormativeConfig' then call it
 *   from browser console after Firebase init, or from a Cloud Function.
 *
 * Uploads TABLA_TOPES and RENTAS_AUTONOMOS from normativaDictamen.js
 * to Firestore at normative_config/current
 */

import { doc, setDoc, serverTimestamp } from 'firebase/firestore'
import { db } from '../firebase-config'
import { TABLA_TOPES, RENTAS_AUTONOMOS } from '../config/normativaDictamen'

export async function seedNormativeConfig() {
  const ref = doc(db, 'normative_config', 'current')
  await setDoc(ref, {
    topes: TABLA_TOPES,
    rentas: RENTAS_AUTONOMOS,
    version: '1.0.0',
    updatedAt: serverTimestamp(),
  })
  return { success: true }
}
